import Navbar from "./Navbar.jsx";

export default function Layout({ children }) {
  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <main className="mx-auto w-full max-w-7xl flex-1 px-4 py-6">{children}</main>
      <footer className="border-t border-ink-200 bg-white">
        <div className="mx-auto max-w-7xl px-4 py-4 text-xs text-ink-400">
          FedRAMP-lite secure environment · Data encrypted in transit and at rest · ©{" "}
          {new Date().getFullYear()} Grant Evaluation Portal
        </div>
      </footer>
    </div>
  );
}
